@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <div
    uiinputcontent
    [class.active]="_active"
    [class]="inputCssClass()"
    (mousedown)="setActive(true)"
    (mouseup)="setActive(false)"
    (mouseleave)="setActive(false)"
  >
    <!--#region Default Icon Left -->

    @if (icon() && settings().iconPosition === 'left') {
      <ng-container *ngTemplateOutlet="uiIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-left]"></ng-content>

    <!--#endregion Default Icon Left -->

    @if (!iconOnly()) {
      <span [UiCopy]="label()" uilabel [class]="inputCssClass()">{{
        label()
      }}</span>
    }

    <!--#region Default Icon Left -->

    @if (icon() && settings().iconPosition !== 'left') {
      <ng-container *ngTemplateOutlet="uiIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-right]"></ng-content>

    <!--#endregion Default Icon Left -->

    <!--#region Popup Content Support -->

    <ng-content select="[UiPopup]"></ng-content>

    <!--#endregion-->

    <!-- Default Icon Template-->
    <ng-template #uiIconTemplateRef>
      <icon
        uidefaulticon
        [iconDefinition]="icon()"
        [iconSize]="iconSize()!"
        [iconColor]="iconColor()"
        [iconCssClass]="iconCssClass()"
      ></icon>
    </ng-template>
  </div>
}
